import { convertLunaDate } from "../../../../function/convertLunaDate";
import { generateCalendarGrid } from "../../../../utilities/genarateMonth";
import ButtonShowCalendar from "./button/ButtonShowCalendar";

const weekDays = ["Hai", "Ba", "Tư", "Năm", "Sáu", "Bảy", "C.N"];

const MonthCard: React.FC<{ year: number; month: number }> = ({
  year,
  month,
}) => {
  const cells = generateCalendarGrid(year, month);

  const isWeekend = (date: Date) => {
    const day = date.getDay();
    return day === 0 || day === 6; // CN hoặc T7
  };

  return (
    <div className="bg-zinc-900 rounded-2xl p-3 shadow-md w-full">
      <h2 className="text-center text-gray-200 text-lg iphone15promax:text-xl  mb-3 font-bold">
        THÁNG {month} - {year}
      </h2>

      {/* Header thứ */}
      <div className="grid grid-cols-7 text-center text-gray-200 mb-2">
        {weekDays.map((w, i) => (
          <div key={i} className={i >= 5 ? "text-red-500" : ""}>
            <p className="text-sm iphone15promax:text-[16px]">{w}</p>
          </div>
        ))}
      </div>

      {/* Grid ngày */}
      <div className="grid grid-cols-7 gap-y-2">
        {cells.map((cell) => {
          const weekend = isWeekend(cell.date);

          // ✅ chuyển sang âm lịch
          const { lunar } = convertLunaDate(cell?.date);
          const lunarData = lunar.get();
          const lunarDay = lunarData.day;
          const lunarMonth = lunarData.month;

          const isSpecialLunarDay = lunarDay === 1 || lunarDay === 15;

          return (
            <ButtonShowCalendar
              cell={cell}
              child={
                <div
                  key={cell.iso}
                  className={`
        flex flex-col items-center font-medium justify-center py-1 ${
          cell?.isToday && "bg-red-500"
        } rounded-lg 
        ${cell?.isCurrentMonth ? "" : "opacity-20"}
        ${weekend ? "text-red-500" : "text-white"}
        ${cell.isToday ? "text-emerald-400 font-bold" : ""}
      `}
                >
                  <div>
                    {" "}
                    <p className="text-xl iphone15promax:text-[27px]">
                      {cell.day}
                    </p>
                  </div>

                  <div
                    className={`
          text-[15px] leading-tight
          ${isSpecialLunarDay ? "text-green-400 font-medium" : "text-gray-300"}
        `}
                  >
                    {lunarDay === 1 || lunarDay === 15
                      ? `${lunarDay}/${lunarMonth}`
                      : lunarDay}
                  </div>
                </div>
              }
            />
          );
        })}
      </div>
    </div>
  );
};

export default MonthCard;
